import React from 'react';
import './HomeMessage.css';
import secretary from '../../../assets/boy.jpg';
function HomeMessage() {
  const messages = [
    
    {
      id: 1,
      title: "Message from the Secretary",
      text: "In our region, there was no college dedicated to students with disabilities, so this institution was established with the mission to educate them, empower them, and help them become successful so they can build their own future with confidence and never feel less than anyone. At the same time, the girls of our village had to travel far from home to pursue higher education, which was difficult and challenging. This college was also founded to ensure that our daughters can study safely, comfortably, and close to home while achieving their dreams.",
      name: "Dr. Bhairoon Singh Bhati",
      role: "S.K. College, Manaklao",
      image: secretary
    }
  ];

  return (
    <section className="home-message-section">
      <div className="home-message-container">
        <h2 className="home-message-section-title">Leadership Messages</h2>

        <div className="home-message-grid">
          {messages.map((item) => (
            <div key={item.id} className="home-message-card">
              
              {/* Passport Style Photo */}
              <div className="home-message-photo-wrapper">
                <div className="home-message-image-frame">
                  <img src={item.image} alt={item.name} className="home-message-passport-photo" />
                </div>
              </div>

              {/* Official Statement Block */}
              <div className="home-message-content">
                <h3 className="home-message-type-title">{item.title}</h3>
                <div className="home-message-divider"></div>
                <p className="home-message-text">"{item.text}"</p>
                <div className="home-message-signature">
                  <h4 className="home-message-name">{item.name}</h4>
                  <span className="home-message-role">{item.role}</span>
                </div>
              </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeMessage;